import React from "react";
import "./style.css";

function Footer(props) {
    return (
    <div className="footer pb-2 mt-5">
        <p className="text-center my-name"><strong>Made by John Russo, 2019</strong></p>
    </div>
    );
  }
  
  export default Footer;